var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Button",class:{ disabled: _vm.disabled },on:{"click":function($event){!_vm.disabled && _vm.$emit('click')}}},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }